<!-- Quantity Change -->
<template>
  <div class="qc-list-page">
    <!-- 좌측 그리드: 수량증가 상위 40위 -->
    <div class="qc-list-section">
      <div class="qc-list-header">
        <span class="red">&lt; 월 최고대비 수량증가 상위 40위 &gt;</span>
      </div>
      <ag-grid-vue
        class="ag-qc-balham increase-grid"
        :columnDefs="increaseColumnDefs"
        :rowData="increaseData"
        :gridOptions="gridOptions"
        :theme="theme"
        :rowHeight="rowHeight"
        @grid-ready="onIncreaseGridReady"
      />
    </div>

    <!-- 우측 그리드: 수량증가 하위 40위 -->
    <div class="qc-list-section">
      <div class="qc-list-header">
        <span class="blue">&lt; 월 최고대비 수량증가 하위 40위 &gt;</span>
      </div>
      <ag-grid-vue
        class="ag-qc-balham decrease-grid"
        :columnDefs="decreaseColumnDefs"
        :rowData="decreaseData"
        :gridOptions="gridOptions"
        :theme="theme"
        :rowHeight="rowHeight"
        @grid-ready="onDecreaseGridReady"
      />
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import axios from "axios";
import "ag-grid-community/styles/ag-grid.css";
import { themeBalham } from "ag-grid-community";

export default {
  name: "QcListPage",
  components: { AgGridVue },
  data() {
    return {
      rowHeight: window.innerWidth > 1024 ? 18.5 : 16, // 행 높이

      theme: themeBalham.withParams({
        fontFamily: "Malgun Gothic",
        // rowHeight: 16,
        borderColor: "#808080",
        wrapperBorder: true,
        headerRowBorder: true,
        headerColumnBorderHeight: '100%',
        rowBorder: { style: "solid", width: 1 },
        columnBorder: { style: "solid", width: 1 },
      }),

      increaseData: [],
      decreaseData: [],

      increaseColumnDefs: [
        {
          headerName: "",
          field: "RANK",
          valueGetter: "node.rowIndex + 1",
          flex: 0.5,
          cellStyle: {
            backgroundColor: "#fecdcd",
            textAlign: "center",
          },
        },
        {
          headerName: "본부명",
          field: "BRANCH_NM",
          flex: 0.8,
          cellStyle: this.gridCellStyle,
        },
        {
          headerName: "점포명",
          field: "SHOP_NM",
          flex: 1.2,
          cellStyle: this.gridCellStyle,
        },
        {
          headerName: "증감률",
          field: "RATE",
          flex: 0.8,
          cellStyle: this.gridCellStyle,
          valueFormatter: (params) =>
            params.value ? `${Number(params.value).toFixed(1)}` : "",
        },
        {
          headerName: "차이",
          field: "GAP",
          flex: 0.8,
          cellStyle: this.gridCellStyle,
          valueFormatter: (params) => params.value?.toLocaleString(),
        },
        {
          headerName: "사업주명",
          field: "SHOP_MASTER_NM",
          flex: 0.8,
          cellStyle: this.gridCellStyle,
        },
        {
          headerName: "나이",
          field: "AGE",
          flex: 0.5,
          cellStyle: this.gridCellStyle,
        },
        {
          headerName: "운영",
          field: "CAREER",
          flex: 0.5,
          cellStyle: this.gridCellStyle,
        },
      ],

      // 하위 40위 그리드는 컬럼 정의만 backgroundColor 변경
      decreaseColumnDefs: [],

      gridOptions: {
        headerHeight: 35,
        rowHeight: 16,
        suppressHorizontalScroll: false,
        suppressDragLeaveHidesColumns: true, // 드래그 후 열 숨기기 방지
        defaultColDef: {
          sortable: true,
          resizable: true,
          headerStyle: {
            color: "black",
            textAlign: "center",
            alignContent: "center",
          },
        },
        domLayout: 'autoHeight',
      },
    };
  },

  created() {
    this.fetchData();
    // 하위 40위 컬럼 정의 복사 및 배경색 변경
    this.decreaseColumnDefs = this.increaseColumnDefs.map((col) => ({
      ...col,
      cellStyle:
        col.field === "RANK"
          ? { backgroundColor: "#bad9fe", textAlign: "center" }
          : col.cellStyle,
    }));
  },

  methods: {
    async fetchData() {
      try {
        const [increaseRes, decreaseRes] = await Promise.all([
          axios.get("/api/qcListPage/increase"),
          axios.get("/api/qcListPage/decrease"),
        ]);

        this.increaseData = increaseRes.data;
        this.decreaseData = decreaseRes.data;
      } catch (error) {
        console.error("데이터 로딩 실패:", error);
      }
    },

    gridCellStyle(params) {
      const style = {};
      const field = params.colDef.field;
      const centerAlignFields = ["BRANCH_NM", "SHOP_NM", "SHOP_MASTER_NM"];

      if (centerAlignFields.includes(field)) {
        style.textAlign = "center";
      } else {
        style.textAlign = "right";
      }

      if (field == "RATE" || field == "GAP") {
        style.color = params.value > 0 ? "#ff0000" : "#0000ff";
      }

      const rowIndex = params.node.rowIndex + 1;
      if (rowIndex === 10) {
        style.backgroundColor = "#ffff80"; // 10번째 행
      } else if (rowIndex === 20) {
        style.backgroundColor = "#80ff80"; // 20번째 행
      } else if (rowIndex === 30) {
        style.backgroundColor = "#80ffff"; // 30번째 행
      } else if (rowIndex === 40) {
        style.backgroundColor = "#9dceff"; // 40번째 행
      }

      return style;
    },

    handleResize() {
      const isWide = window.innerWidth > 1024;
      const newRowHeight = isWide ? 18.5 : 16;
      if (this.rowHeight !== newRowHeight) {
        this.rowHeight = newRowHeight;
        if (this.gridApi) this.gridApi.resetRowHeights();
      }
    },

    onIncreaseGridReady(params) {
      this.increaseGridApi = params.api;
    },

    onDecreaseGridReady(params) {
      this.decreaseGridApi = params.api;
    },
  },

  mounted() {
    window.addEventListener("resize", this.handleResize);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
.qc-list-page {
  display: flex;
  gap: 15px;
  padding: 2px 15px;
  height: 97%;
}

.qc-list-section {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.qc-list-header {
  text-align: center;
  white-space: nowrap;
  font-size: 1.2rem;
}

.qc-list-header .red {
  color: #ff0000;
}

.qc-list-header .blue {
  color: #0000ff;
}

:deep(.ag-qc-balham) {
  height: calc(100vh - 120px);
  --ag-cell-horizontal-padding: 3px; /* 셀 내부 좌우 패딩 */
  /* --ag-header-height: 30px;
  --ag-row-height: 25px;
  --ag-header-background-color: #f0f0f0;
  --ag-odd-row-background-color: #ffffff;
  --ag-even-row-background-color: #f8f8f8; */
}

/* 상위 40위 그리드 헤더 배경색 */
:deep(.increase-grid .ag-header-cell) {
  background-color: #fecdcd;
}

/* 하위 40위 그리드 헤더 배경색 */
:deep(.decrease-grid .ag-header-cell) {
  background-color: #bad9fe;
}

:deep(.ag-header-cell-label) {
  justify-content: center;
}

:deep(.ag-cell) {
  font-size: 0.8rem;
}

/* 1024px 초과일 때 폰트/행 높이 증가 */
@media (min-width: 1025px) {
  :deep(.ag-qc-balham .ag-cell) {
    font-size: 1rem;
  }
}
</style>
